import { FeatureCollection } from '@turf/turf'
//@ts-ignore soon: https://deck.gl/docs/get-started/using-with-typescript
import { ViewMode } from '@nebula.gl/edit-modes'
import { Dispatch, SetStateAction, createContext } from 'react'
import { EditorMode } from '../GeometryEditorTypes'

export type GeometryEditorToolsContextValue = {
  copyBuffer?: FeatureCollection
  setCopyBuffer: Dispatch<SetStateAction<FeatureCollection | undefined>>
  nextMode?: EditorMode
  setNextMode: Dispatch<SetStateAction<EditorMode | undefined>>
  mode: EditorMode
  setMode: Dispatch<SetStateAction<EditorMode>>
  marqueeFeatures?: FeatureCollection
  setMarqueeFeatures: Dispatch<SetStateAction<FeatureCollection>>
  handleCopy: () => void
  handlePaste: () => void
  handleImmediateDifference: (marquee: FeatureCollection) => void
  handleDifference: () => void
  handleDifferenceSelected: () => void
  handleDeleteSelected: () => void
  handleRecenterMap: () => void
  handleUpdateMode: (newMode: typeof ViewMode, modeConfig: any) => void
  handleZoomIn: () => void
  handleZoomOut: () => void
  handleViewStateChange: (vs: any) => void
}

export const GeometryEditorToolsContext = createContext<GeometryEditorToolsContextValue>({
  mode: {
    editLayer: {
      mode: ViewMode,
      modeConfig: {},
    },
    marqueeLayer: {
      mode: ViewMode,
      modeConfig: {},
    },
    isMarquee: false,
    isTransform: false,
  },
  setMode: a => console.log('setMode unset'),
  setCopyBuffer: a => console.log('setCopyBuffer unset'),
  setNextMode: a => console.log('setNextMode unset'),
  setMarqueeFeatures: a => console.log('setMarqueeFeatures unset'),
  handleCopy: () => console.log('handleCopy unset'),
  handlePaste: () => console.log('handlePaste unset'),
  handleImmediateDifference: a => console.log('handleImmediateDifference unset'),
  handleDifference: () => console.log('handleDifference unset'),
  handleDifferenceSelected: () => console.log('handleDifferenceSelected unset'),
  handleDeleteSelected: () => console.log('handleDeleteSelected unset'),
  handleRecenterMap: () => console.log('handleRecenterMap unset'),
  handleUpdateMode: (newMode: typeof ViewMode, modeConfig: any) =>
    console.log('handleUpdateMode unset'),
  handleZoomIn: () => console.log('handleZoomIn unset'),
  handleZoomOut: () => console.log('handleZoomOut unset'),
  handleViewStateChange: (vs: any) => console.log('handleViewStateChange unset'),
})
GeometryEditorToolsContext.displayName = 'GeometryEditorToolsContext'
